<template>
    <div class="">
        
        <template>
            <the-header />
        </template>

        <div class="site-wrapper-reveal">
            <div class="about-banner-wrap banner-space about-us-bg position-relative">
                <div class="banner-overlay"></div>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-8 ml-auto mr-auto">
                            <div class="about-banner-content text-center">
                                <h1 class="mb-15 text-white">Property Management</h1>
                                <h5 class="font-weight--normal text-white">Proven 15 years’ track record in property management. </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="feature-large-images-wrapper section-space--ptb_100">
                <div class="container">
                    <div class="cybersecurity-about-box">
                        <div class="row">
                            <div class="col-lg-7">
                                <div class="modern-number-01 widget-blog-recent-post">
                                    <h1 class="heading text-color-primary">Axis Realty Group LLC</h1>
                                    <h4 class="heading mt-4">Enjoy these benefits from a respected name in property management</h4>
                                    <ul class="list-custome my-4">
                                        <li class="list-item"><a href="javascript:void(0);">LOWER FEES</a></li>
                                        <li class="list-item"><a href="javascript:void(0);">TAILOR-MADE PROPERTY MANAGEMENT SOLUTIONS</a></li>
                                        <li class="list-item"><a href="javascript:void(0);">PROVEN TRACK RECORD</a></li>
                                    </ul>
                                </div>
                            </div>

                            <div class="col-lg-5">
                                <div class="button-group-wrap text-right">
                                    <router-link :to="`${baseUrl}/apply-for-rental`" class="ht-btn ht-btn-md mr-md-3 mb-5 inline-block text-white">Apply For Rental</router-link>
                                    <router-link :to="`${baseUrl}/contact-us`" class="ht-btn ht-btn-md ht-btn--solid inline-block">Inquire Now</router-link>
                                </div>
                            </div>
                        </div> 
                        <div class="row">
                            <div class="col-lg-12">    
                                <div class="main-video-box video-popup">
                                    <a href="" class="video-link  mt-30">
                                        <div class="single-popup-wrap">
                                            <img class="img-fluid border-radus-5" src="@/assets/images/banners/axis-realty-group-video-bg.jpg" alt="Axis Realty Group" />
                                            <!-- <div class="ht-popup-video video-button">
                                                <div class="video-mark">
                                                    <div class="wave-pulse wave-pulse-1"></div>
                                                    <div class="wave-pulse wave-pulse-2"></div>
                                                </div>
                                                <div class="video-button__two">
                                                    <div class="video-play">
                                                        <span class="video-play-icon"></span>
                                                    </div>
                                                </div>
                                            </div> -->
                                        </div>
                                    </a>
                                </div>                            
                                <div class="cybersecurity-about-text mt-12">                                    
                                    <h2 class="heading">Axis Realty Group Area Info</h2>
                                    <div class="text mt-6">
                                        We are Axis Realty Group, your trusted partner in property management. We deal in a wide range of residential property types, including single-family homes, multi-complexes, and homeowner associations.
                                    </div>                                     
                                    <div class="text">Our objective is to provide solutions for property management challenges so as to free up time for our clients to develop their property portfolios and generally take away the headaches that come with property management.</div>  
                                    <div class="text">
                                        When you engage us, we provide the following services, which we execute with the highest level of diligence:
                                    </div>
                                    <ol class="automatic-numbered-list">
                                        <li class="list-item"><h4 class="font-medium mb-2">Helping you set the right rental rate using thoroughly researched market data.</h4>
                                        <p class="text">Based on your property’s location, condition, demand for housing, and comparison with
                                        similar properties, we are able to provide useful insights on the rates you should be charging
                                        so that you don’t overprice or under-price your property.</p></li>
                                        <li class="list-item"><h4 class="font-medium mb-2">Marketing and advertising your property</h4>
                                        <p class="text">We run an electronic database that quickly puts rentals out in the market immediately; they
                                        fall vacant. We advertise your property through our website and other electronic outlets, as
                                        well as via print media and the use of referrals. We also organize property showings to
                                        prospective clients. Using all the tools at our disposal, we’re able to do efficient and timely
                                        tenant placement, which reduces the vacancy time of your property.</p>
                                        </li>
                                        <li class="list-item"><h4 class="font-medium mb-2">Rent collection</h4>
                                        <p class="text">Our office handles all rent collections, including cases of subsidized rent, where we ensure
                                        all the necessary paperwork is filled out. We diligently remit all collections into the
                                        respective owners’ accounts as quickly and efficiently as possible. As for rent arrears, we
                                        have a team of staff dedicated to tracking late payments and who continuously follow up
                                        with tenants to ensure we meet our rent collection targets.</p>
                                        </li>
                                        <li class="list-item"><h4 class="font-medium mb-2">Tenant screening</h4>
                                        <p class="text">We screen all potential tenants using credit reports, employment records, eviction history,
                                        as well as criminal background checks to minimize the possibility of renting out your
                                        property to rent defaulters, tenants who are a nuisance, or who can damage your property.
                                        By taking these extra precautions, we improve the chances of acquiring quality tenants that
                                        pay on time and stay longer, and who take good care of the rental unit.</p>
                                        </li>
                                        <li class="list-item"><h4 class="font-medium mb-2">Maintenance and repair work</h4>
                                        <p class="text">Scheduling routine and emergency maintenance is an important part of our work as
                                        property managers. We carry out the supervision of works to ensure a quality job is always
                                        done at a fair price. We also run an around-the-clock answering service to receive tenants&#39;
                                        requests for repairs, which we embark on based on the urgency of the repair work. By using
                                        our in house team for repair work, we are able to give more value for money to the property
                                        owner.</p>
                                        </li>
                                        <li class="list-item"><h4 class="font-medium mb-2">Handling communication</h4>
                                        <p class="text">We take care of relationships with tenants as well as with vendors, ensuring there is
                                        continued harmony. We also keep you informed on any developments regarding your
                                        property that is important for you to know.</p>
                                        </li>
                                        <li class="list-item"><h4 class="font-medium mb-2">Helping you abide by with housing regulations and property laws</h4>
                                        <p class="text">We bring a wealth of knowledge on municipality codes, as well as the permits and
                                        occupancy inspections that are necessary during a move in. This way, you avoid incurring
                                        exorbitant fines for failing to comply with regulations that govern the renting of property.</p>
                                        </li>
                                        <li class="list-item"><h4 class="font-medium mb-2">Legal proceedings</h4>
                                        <p class="text">In cases where legal action is required for continued defaulting on rent by a tenant, we work
                                        as your agent in conjunction with an attorney to begin the eviction process. This means you
                                        don’t have to worry about filing proper paperwork or appearing in court because we act on
                                        your behalf, ensuring the process moves forward as quickly and efficiently as possible.</p>
                                        </li>
                                        <li class="list-item"><h4 class="font-medium mb-2">Accounting</h4>
                                        <p class="text">We maintain proper accounts on all monetary activities related to your property. We
                                        provide timely monthly statements that show in detail all transactions that affect your
                                        account balance. Upon request, we can also furnish you with a summary of the year-to-date
                                        transactions for your property account.</p>
                                        </li>
                                        <li class="list-item"><h4 class="font-medium mb-2">Lease signing</h4>
                                        <p class="text">We handle lease signing on your behalf, ensuring that we only use leases that can stand up
                                        to legal scrutiny and abide by all statutes and regulations for the State of Missouri.</p>
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
            
        <the-footer />
    </div>
</template>

<script>
import TheHeader   from '@/layouts/components/TheHeader.vue'
import TheFooter   from '@/layouts/components/TheFooter.vue'

export default {
  components: {
    TheHeader,
    TheFooter
  },
  data () {
    return {
    }
  },
  methods: {
  },
  computed: {
    baseUrl () {
      const path = this.$route.path
      return path.slice(0, ('/'))
    }
  }

}
</script>